export default class BusEvent {
    id = null
    payload = null

    constructor(payload = null) {
        this.id = '_' + Math.random()
        this.payload = payload
    }
}